import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';

function AddMenus({ handleNewMenu, editMenu }) {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [nombremenu, setNombreMenu] = useState('');
    const [iconomenu, setIconoMenu] = useState('');
    const [idmenupadre, setIdMenupadre] = useState('');
    const [href, setHref] = useState('');
    const [estado, setEstado] = useState(false);
    const [posicion, setPosicion] = useState('');

    const [menus, setMenus] = useState([]);
    const { user } = useUser();

    // Cargar los datos del menú para editar
    useEffect(() => {
        if (editMenu) {
            setNombreMenu(editMenu.nombre_menu);
            setIconoMenu(editMenu.icono_menu);
            setHref(editMenu.href);
            setIdMenupadre(editMenu.id_menu_padre != null ? String(editMenu.id_menu_padre) : '');
            setEstado(editMenu.estado);
            setPosicion(editMenu.posicion);
        } else {
            resetForm();
        }
    }, [editMenu]);

    useEffect(() => {
        const fetchMenus = async () => {
            try {
                const response = await fetch(`${server}/sg_menu`);
                const data = await response.json();
                setMenus(data.$values);
            } catch (error) {
                console.error('Error al cargar los menus:', error);
            }
        };

        fetchMenus();
    }, []);

    const resetForm = () => {
        setNombreMenu('');
        setIconoMenu('');
        setHref('');
        setIdMenupadre('');
        setEstado(false);
        setPosicion('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const method = editMenu ? 'PUT' : 'POST';
        const endpoint = editMenu ? `${server}/sg_menu/${editMenu.id}` : `${server}/sg_menu`;

        const usuario = user ? user.codigoUsuario.padEnd(20) : 'Desconocido'.padEnd(20);

        const menu = {
            ...(editMenu && { id: editMenu.id }),
            nombre_menu: nombremenu,
            icono_menu: iconomenu,
            href: href,
            ...(editMenu
                ? { modificadoPor: usuario }
                : { ingresadoPor: usuario }),
            estado,
            posicion,
            id_menu_padre: idmenupadre ? parseInt(idmenupadre, 10) : null
        };

        try {
            const response = await fetch(endpoint, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(menu),
            });

            if (response.ok) {
                resetForm();
                Swal.fire({
                    icon: 'success',
                    title: 'Menú guardado con éxito',
                    showConfirmButton: false,
                    timer: 1500
                });
                // alert('Menú guardado con éxito');
                handleNewMenu();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al guardar el menú.',
                    timer: 3000,
                    showConfirmButton: false
                });
               
            }
        } catch (error) {
            console.error('Error al guardar el menú:', error);
            alert('Error al guardar el menú');
        }
    };

    return (
        <form id="InsertarMenu" data-parsley-validate className="form-horizontal form-label-left" onSubmit={handleSubmit}>
            <div className="item form-group">
                <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="nombreMenu">Nombre Menú <span className="required">*</span></label>
                <div className="col-md-4 col-sm-6">
                    <input
                        type="text"
                        id="nombreMenu"
                        required="required"
                        className="form-control"
                        value={nombremenu}
                        onChange={(e) => setNombreMenu(e.target.value)}
                    />
                </div>
            </div>
            <div className="item form-group">
                <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="icono">Icono <span className="required">*</span></label>
                <div className="col-md-4 col-sm-6">
                    <input
                        type="text"
                        id="icono"
                        required="required"
                        className="form-control"
                        value={iconomenu}
                        onChange={(e) => setIconoMenu(e.target.value)}
                    />
                </div>
            </div>
            <div className="item form-group">
                <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="link">Link <span className="required">*</span></label>
                <div className="col-md-4 col-sm-6">
                    <input
                        type="text"
                        id="link"
                        required="required"
                        className="form-control"
                        value={href}
                        onChange={(e) => setHref(e.target.value)}
                    />
                </div>
            </div>
            <div className="item form-group">
                <label className="control-label col-md-3 col-sm-3 label-align" htmlFor="menuPadre">Menú Padre</label>
                <div className="col-md-4 col-sm-6">
                    <select className="form-control" value={idmenupadre} onChange={(e) => setIdMenupadre(e.target.value)}>
                        <option value="">Elija una opción</option>
                        {menus.map((menu) => (
                            <option key={menu.id} value={menu.id}>{menu.nombre_menu}</option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="item form-group">
                <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="posicion">Posición <span className="required">*</span></label>
                <div className="col-md-4 col-sm-6">
                    <input
                        type="text"
                        id="posicion"
                        required="required"
                        className="form-control"
                        value={posicion}
                        onChange={(e) => setPosicion(e.target.value)}
                    />
                </div>
            </div>
            <div className="item form-group">
                <label className="col-form-label col-md-3 col-sm-3 label-align">Estado</label>
                <div className="col-md-1 col-sm-6">
                    <label>
                        <input
                            type="checkbox"
                            id="estado"
                            checked={estado}
                            onChange={(e) => setEstado(e.target.checked)}
                        /> Activo
                    </label>
                </div>
            </div>
            <div className="ln_solid" />
            <div className="item form-group">
                <div className="col-md-6 col-sm-6 offset-md-3">
                    <button className="btn btn-primary" type="reset">Limpiar</button>
                    <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Menú')}>Aceptar</button>
                </div>
            </div>
        </form>
    );
}

export default AddMenus;
